import React, { useContext } from "react";
import { useHistory, Link, NavLink } from "react-router-dom";
import Utils from "../Common/Utils";
import { AppContext } from "../Context/AppContext";

function Dashboard(props) {
  const history = useHistory();
  const appData = useContext(AppContext);



  React.useEffect(() => {
    Utils.SetWindowTitle("Dashboard");
  }, []);
  return (
    <>
      <div className="container-fluid ps-0">
        <h2 className="text-xl font-bold pl-4 py-3">Dashboard</h2>
        <hr />
        <div className="row ps-3">
          {!Utils.isUndefinedOrNull(appData.get_selected_industry()) && (
            <div className="col-sm-4 tw-mt-3  p-0">
              <div className="card border-dark mb-4">
                {/* <div className="card-header">Taxonomy</div> */}
                <div className="card-body text-dark space-y-4">
                  <h5 className="card-title text-xl">GMS</h5>
                  <p className="card-text">
                    Some quick example text to build on the card title and make
                    up the bulk of the card&apos;s content.
                  </p>
                  {/* <button
                    className="btn btn-primary btn-sm tw-mt-2"
                    onClick={() => history.replace("/gms/dashboard")}
                  >
                    Explore
                  </button> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Dashboard;
